import { SlidingDoorComponent } from '@inter-ikea-storageone/range';
import { deleteUncoupledSlidingDoors } from '@inter-ikea-storageone/range-platsa';
import { ComponentIds, Entity, HierarchyUtils, Nullable } from '@inter-ikea-core/core';
import { BehaviorParameters } from 'rangeConfig/@types';
import { deleteFrontLayout } from '../utils/frontLayouts';

const deleteFrontLayoutBehavior = ({ coreApi }: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  const slidingDoorsInScene = coreApi.entities.getByComponent(SlidingDoorComponent.id);
  let frame: Nullable<Entity> = null;
  if (selectedEntity?.hasComponent(ComponentIds.FRAME_COMPONENT_ID)) {
    frame = selectedEntity;
  } else if (
    selectedEntity?.hasComponent(ComponentIds.DOOR_COMPONENT_ID) ||
    selectedEntity?.hasComponent(ComponentIds.DRAWER_COMPONENT_ID) ||
    selectedEntity?.hasComponent(SlidingDoorComponent.id)
  ) {
    frame = HierarchyUtils.findWithComponentInUpwardsHierarchy(
      selectedEntity,
      ComponentIds.FRAME_COMPONENT_ID
    );
  }
  if (!frame) return;
  deleteFrontLayout(frame as Entity, coreApi, undefined, false);
  if (slidingDoorsInScene) {
    deleteUncoupledSlidingDoors(coreApi);
  }
};

export default deleteFrontLayoutBehavior;
